/*
 This file is part of GNU Taler
 (C) 2021-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

/**
 *
 * @author Sebastian Javier Marchano (sebasjm)
 */

import {
  HttpStatusCode,
  TalerError,
  TalerMerchantApi,
  assertUnreachable
} from "@gnu-taler/taler-util";
import { Fragment, VNode, h } from "preact";
import { ErrorLoadingMerchant } from "../../../components/ErrorLoadingMerchant.js";
import { Loading } from "../../../components/exception/loading.js";
import { useBackendInstances } from "../../../hooks/instance.js";
import { LoginPage } from "../../login/index.js";
import { View } from "./View.js";

interface Props {
  onCreate: () => void;
  onUpdate: (id: string) => void;
  onChangePassword: (id: string) => void;
  instances: TalerMerchantApi.Instance[];
}

export default function Instances({
  onCreate,
  onUpdate,
  onChangePassword,
}: Props): VNode {
  const result = useBackendInstances();

  if (!result) return <Loading />;
  if (result instanceof TalerError) {
    return <ErrorLoadingMerchant error={result} />;
  }
  if (result.type === "fail") {
    switch (result.case) {
      case HttpStatusCode.Unauthorized: {
        return <LoginPage focus />;
      }
      default: {
        assertUnreachable(result);
      }
    }
  }


  return (
    <Fragment>
      <View
        instances={result.body.instances}
        onUpdate={onUpdate}
        onChangePassword={onChangePassword}
        onCreate={onCreate}
        
      />
    </Fragment>
  );
}
